module.exports = __webpack_public_path__ + "static/media/react.ae40efa7.png";